<template>
  <div>
    <div class="main" v-if="type == 1">
      <div class="subNav"><a @click="changType(1)" class="juventus">尤文图斯官方区域合作伙伴</a> <a @click="changType(2)" class="avfc">阿斯顿维拉官方全球顶级合作伙伴</a></div>
      <div class="wrap">
        <div id="mainSwiper" class="swiper_wrap swiper-container swiper-container-initialized swiper-container-vertical" style="overflow-y: auto">
          <div class="swiper_wrap swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
            <img src="/static/image/banner-1.55bcde09ee8cab8b010f9b6c2b9a066b.jpg" alt="" />

            <div id="video" class="swiper-slide section section_one swiper-slide-next">
              <div class="football">
                <div class="football_info">
                  <h3 style="margin-bottom: 0"><span class="line-vertical"></span> 官宣视频</h3>
                  <div class="video_box">
                    <div class="video_box_img">
                      <video poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-1.bed592d671889693ffb58982cc59a59c.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp" style="" class="video" controls="true" preload="none">
                        <source src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventus1.4c63aa193493ea9598403b1bef9eef70.mp4" type="video/mp4" />
                      </video>
                    </div>
                    <div class="football_text">
                      <p>
                        北京时间2020年9月18日，意甲豪门尤文图斯足球俱乐部与亚洲领先体育娱乐平台之一的{{$store.state.appInfo.title}}举行官方签约仪式正式宣布双方合作关系。{{$store.state.appInfo.title}}全球关系发展总监兼发言人William Robert与尤文图斯亚太区董事总经理Federico
                        Palomba共同出席并签署赞助协议。自此，{{$store.state.appInfo.title}}正式成为尤文图斯官方区域合作伙伴，两家知名品牌将通过深入合作，共同 “携手拼搏，直至巅峰，竭力为用户提供最佳体育与娱乐体验”。
                      </p>
                      <div class="btn btn1">
                        <img
                          data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/jinruyouwentusianniu@2x.b47747a482585b72471363b4f765cb6f.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          width="undefined"
                          height="undefined"
                          style=""
                          src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/jinruyouwentusianniu@2x.b47747a482585b72471363b4f765cb6f.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="boxContent">
                  <div class="swiper-container1 swiper-container-initialized swiper-container-horizontal">
                    <div class="swiper-wrapper" style="transform: translate3d(-1160px, 0px, 0px); transition: all 0ms ease 0s">
                      <ul class="swiper-slide swiper-slide-duplicate swiper-slide-prev swiper-slide-duplicate-next" data-swiper-slide-index="1" style="width: 1160px">
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventus2.f81e5d37cc7473b8c91369c11d9db782.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-2.5f04d9e7f078e368361d5e326e28fd8b.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-2.5f04d9e7f078e368361d5e326e28fd8b.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-2.5f04d9e7f078e368361d5e326e28fd8b.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯3:0桑普多利亚</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <i onclick="showPlayer(false)"></i>
                          <img
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/valencia-web/nodata.ccb7955dad4982f09ef7d4ad4d716e40.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            width="undefined"
                            height="undefined"
                            style=""
                            src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/valencia-web/nodata.ccb7955dad4982f09ef7d4ad4d716e40.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          />
                          <div class="videoTit">敬请期待</div>
                        </li>
                      </ul>
                      <ul class="swiper-slide video-item swiper-slide-active" data-swiper-slide-index="0" style="width: 1160px">
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/newSpring.acf2d708f5e260592fcbe4687ae990e8.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-newyear.dd951c8bf8c3678d18c30e9dddd35ff1.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-newyear.dd951c8bf8c3678d18c30e9dddd35ff1.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-newyear.dd951c8bf8c3678d18c30e9dddd35ff1.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯与您共度新春佳节</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventusOct.27752b75bced5419e1f3bc364877e09e.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-5.0f0ad02f4d063e5d053a8816e4a75fbd.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-5.0f0ad02f4d063e5d053a8816e4a75fbd.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-5.0f0ad02f4d063e5d053a8816e4a75fbd.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯10月精彩进球集锦</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventus3.421cffe70f261baea20528e6c689843e.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-4.3dbfc0aa887030d55ae29dbe9fa05463.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-4.3dbfc0aa887030d55ae29dbe9fa05463.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-4.3dbfc0aa887030d55ae29dbe9fa05463.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯1:1维罗纳</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventusSep.d8aae9bed3f96e2e2f0aa90b9ecb7f50.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-3.091956f20461ce4edc5934183066b09a.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-3.091956f20461ce4edc5934183066b09a.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-3.091956f20461ce4edc5934183066b09a.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯9月精彩进球集锦</p>
                          </div>
                        </li>
                      </ul>
                      <ul class="swiper-slide swiper-slide-next swiper-slide-duplicate-prev" data-swiper-slide-index="1" style="width: 1160px">
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventus2.f81e5d37cc7473b8c91369c11d9db782.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-2.5f04d9e7f078e368361d5e326e28fd8b.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-2.5f04d9e7f078e368361d5e326e28fd8b.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-2.5f04d9e7f078e368361d5e326e28fd8b.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯3:0桑普多利亚</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <i onclick="showPlayer(false)"></i>
                          <img
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/valencia-web/nodata.ccb7955dad4982f09ef7d4ad4d716e40.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            width="undefined"
                            height="undefined"
                            style=""
                            src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/valencia-web/nodata.ccb7955dad4982f09ef7d4ad4d716e40.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          />
                          <div class="videoTit">敬请期待</div>
                        </li>
                      </ul>
                      <ul class="swiper-slide video-item swiper-slide-duplicate swiper-slide-duplicate-active" data-swiper-slide-index="0" style="width: 1160px">
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/newSpring.acf2d708f5e260592fcbe4687ae990e8.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-newyear.dd951c8bf8c3678d18c30e9dddd35ff1.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-newyear.dd951c8bf8c3678d18c30e9dddd35ff1.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-newyear.dd951c8bf8c3678d18c30e9dddd35ff1.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯与您共度新春佳节</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventusOct.27752b75bced5419e1f3bc364877e09e.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-5.0f0ad02f4d063e5d053a8816e4a75fbd.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-5.0f0ad02f4d063e5d053a8816e4a75fbd.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-5.0f0ad02f4d063e5d053a8816e4a75fbd.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯10月精彩进球集锦</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventus3.421cffe70f261baea20528e6c689843e.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-4.3dbfc0aa887030d55ae29dbe9fa05463.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-4.3dbfc0aa887030d55ae29dbe9fa05463.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-4.3dbfc0aa887030d55ae29dbe9fa05463.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯1:1维罗纳</p>
                          </div>
                        </li>
                        <li class="slide-item">
                          <div
                            class="video_item"
                            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/juventusSep.d8aae9bed3f96e2e2f0aa90b9ecb7f50.mp4"
                            data-poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-3.091956f20461ce4edc5934183066b09a.jpg"
                          >
                            <i class="play_icon"></i>
                            <img
                              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-3.091956f20461ce4edc5934183066b09a.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                              width="undefined"
                              height="undefined"
                              style=""
                              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/poster-3.091956f20461ce4edc5934183066b09a.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                            />
                            <p>尤文图斯9月精彩进球集锦</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <!-- 如果需要分页器 -->
                    <div class="swiper-pagination1 swiper-pagination-bullets"><span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span><span class="swiper-pagination-bullet"></span></div>
                    <!-- 如果需要导航按钮 -->
                    <div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide"><span></span></div>
                    <div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide"><span></span></div>
                    <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                  </div>
                </div>
              </div>
            </div>
            <div id="info" class="swiper-slide section section_two">
              <div class="sponsor_box">
                <div class="sponsor_img_box">
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/sponsor-img.00b028f11dcd3fa07222df88d18d1ece.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style=""
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/sponsor-img.00b028f11dcd3fa07222df88d18d1ece.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <div class="sponsor_text_box">
                    <h3 class="football_info">意甲尤文图斯足球俱乐部</h3>
                    <p>
                      尤文图斯——意大利足球的领军俱乐部，在截止到2020年这九年间，创纪录地连续九次夺得意甲联赛冠军，完成队史上38次夺得意甲联赛冠军的壮举。而在欧战赛场上，尤文更是欧陆第一支把欧洲三大杯（欧洲冠军杯，欧洲联盟杯，欧洲优胜者杯）都收入囊中的球队。尤文图斯，不仅是意大利的冠军队伍，也是欧战的强劲团队。
                    </p>
                  </div>
                </div>
                <div class="honor_list_box">
                  <h3 class="football_info"><span class="line-vertical"></span>荣誉</h3>
                  <div class="honor_list">
                    <div class="honor_item">
                      <img
                        data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-1.cca7ac2d153d5162e9e829ec937191d3.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        width="undefined"
                        height="undefined"
                        style=""
                        src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-1.cca7ac2d153d5162e9e829ec937191d3.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      />
                      <div class="honor_text_box"><b>38</b> <span>意大利甲级联赛冠军</span></div>
                    </div>
                    <div class="honor_item">
                      <img
                        data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-2.1f7e7d3b8072e021760df2f0237a6e24.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        width="undefined"
                        height="undefined"
                        style=""
                        src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-2.1f7e7d3b8072e021760df2f0237a6e24.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      />
                      <div class="honor_text_box"><b>13</b> <span>意大利杯冠军</span></div>
                    </div>
                    <div class="honor_item">
                      <img
                        data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        width="undefined"
                        height="undefined"
                        style=""
                        src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      />
                      <div class="honor_text_box"><b>8</b> <span>意大利超级杯冠军</span></div>
                    </div>
                    <div class="honor_item">
                      <img
                        data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        width="undefined"
                        height="undefined"
                        style=""
                        src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      />
                      <div class="honor_text_box"><b>2</b> <span>欧洲冠军联赛奖杯</span></div>
                    </div>
                    <div class="honor_item">
                      <img
                        data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        width="undefined"
                        height="undefined"
                        style=""
                        src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      />
                      <div class="honor_text_box"><b>3</b> <span>欧洲联盟杯/欧洲联赛冠军</span></div>
                    </div>
                    <div class="honor_item">
                      <img
                        data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        width="undefined"
                        height="undefined"
                        style=""
                        src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/honor-3.99e0d3b5d7b412901d817790d5725d56.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      />
                      <div class="honor_text_box"><b>2</b> <span>欧洲超级杯冠军</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="picture" class="swiper-slide section section_third">
              <div class="pic_box">
                <div class="pic_title">
                  <span></span>
                  <h3>球队日常图集</h3>
                </div>
                <div class="pics">
                  <div class="pic_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-1.5538672a58f1f2cf3348e03cb062f505.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style="width: 276px; height: 428px"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-1.5538672a58f1f2cf3348e03cb062f505.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <div class="pic_text_box">
                      <h3></h3>
                      <p></p>
                    </div>
                  </div>
                  <div class="pic_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-2.e2487821cf3070d4fd0ce69c3f1d5aab.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style="width: 570px; height: 428px"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-2.e2487821cf3070d4fd0ce69c3f1d5aab.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <div class="pic_text_box">
                      <h3></h3>
                      <p></p>
                    </div>
                  </div>
                  <div class="pic_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-3.31ffa625f653c956a16d0ad4c0c6e0c9.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style="width: 275px; height: 275px"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-3.31ffa625f653c956a16d0ad4c0c6e0c9.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <div class="pic_text_box">
                      <h3>训练照片</h3>
                      <p>刻苦训练的尤文球员，图中球员分别为库卢塞夫斯基、阿图尔、莫拉塔、麦肯尼</p>
                    </div>
                  </div>
                  <div class="pic_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-4.0b1237704f345d668a69b0d6c84f9bea.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style="width: 275px; height: 259px"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-4.0b1237704f345d668a69b0d6c84f9bea.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <div class="pic_text_box">
                      <h3></h3>
                      <p>比赛照片，与罗马的比赛中，摆脱对手的拉比奥特</p>
                    </div>
                  </div>
                  <div class="pic_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-5.9360f9aeafa9f66ab87564635f4e286c.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style="width: 275px; height: 259px"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-5.9360f9aeafa9f66ab87564635f4e286c.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <div class="pic_text_box">
                      <h3></h3>
                      <p>比赛照片，球队中场大将拉比奥特在观察场上形势</p>
                    </div>
                  </div>
                  <div class="pic_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-6.0612999fa2323cda0e64eca915308ee0.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style="width: 275px; height: 259px"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-6.0612999fa2323cda0e64eca915308ee0.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <div class="pic_text_box">
                      <h3></h3>
                      <p>尤文图斯VS维罗纳赛前首发球员合照</p>
                    </div>
                  </div>
                  <div class="pic_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-7.529e7c6d921d5969bc4f548d7cb9d4f8.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style="width: 275px; height: 259px"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/picture-7.529e7c6d921d5969bc4f548d7cb9d4f8.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <div class="pic_text_box">
                      <h3></h3>
                      <p>比赛照片，阿根廷球星迪巴拉</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="service" class="swiper-slide section section_four">
              <div class="service">
                <div class="service_box">
                  <div class="app_img">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/service-app.38499c781fb6dc413a0ebe18de86ae6e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/service-app.38499c781fb6dc413a0ebe18de86ae6e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                  </div>
                  <div class="service_content">
                    <h2>业内最顶尖的原生APP</h2>
                    <div class="service_icons">
                      <div class="service_icon">
                        <img
                          data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-1.17378a734f5a7fdc12600fe8ad34b1f0.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          width="undefined"
                          height="undefined"
                          style=""
                          src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-1.17378a734f5a7fdc12600fe8ad34b1f0.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        />
                        <h3>更安全</h3>
                        <p>
                          独家网络技术 <br />
                          超强防劫持
                        </p>
                      </div>
                      <div class="service_icon">
                        <img
                          data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-2.c95d87fc455a5e81ba05b879b2358995.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          width="undefined"
                          height="undefined"
                          style=""
                          src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-2.c95d87fc455a5e81ba05b879b2358995.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        />
                        <h3>更稳定</h3>
                        <p>
                          强大的技术团队 <br />
                          提供最稳定的产品
                        </p>
                      </div>
                      <div class="service_icon">
                        <img
                          data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-3.6233d635883f80c8813393d8662e439f.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          width="undefined"
                          height="undefined"
                          style=""
                          src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-3.6233d635883f80c8813393d8662e439f.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        />
                        <h3>更丰富</h3>
                        <p>
                          丰富的游戏产品 <br />
                          您想要的我们都有
                        </p>
                      </div>
                      <div class="service_icon">
                        <img
                          data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-4.7090bd8d1486bdab2e39259f20bee15c.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          width="undefined"
                          height="undefined"
                          style=""
                          src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/invalid-4.7090bd8d1486bdab2e39259f20bee15c.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        />
                        <h3>更私密</h3>
                        <p>
                          三重数据加密 <br />
                          保护您的资料安全
                        </p>
                      </div>
                    </div>
                    <div class="logo_box">
                      <div class="logo_item service_logo3">
                        <img
                          data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/service-logo-3.b6cfffb103a336bbcdb77c9440e436c2.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                          width="undefined"
                          height="undefined"
                          style=""
                          src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/service-logo-3.b6cfffb103a336bbcdb77c9440e436c2.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="license_box" style="">
                  <div class="license">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/license-2.74b5f7a2333fb0b9882fb732772b2c30.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/license-2.74b5f7a2333fb0b9882fb732772b2c30.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <p style="">马耳他牌照（MGA）认证</p>
                  </div>
                  <div class="license">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/license-3.1628b60d61f1baf3f6acb052a5c6f8ab.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/license-3.1628b60d61f1baf3f6acb052a5c6f8ab.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <p style="">英属维尔京群岛（BVI）认证</p>
                  </div>
                  <div class="license">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/license-4.ca240aa025d6f9579a10d9c399b0dbbc.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/license-4.ca240aa025d6f9579a10d9c399b0dbbc.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <p style="">菲律宾（PAGCOR）监督牌照</p>
                  </div>
                </div>
              </div>
            </div>
            <div id="players" class="swiper-slide section section_five">
              <div class="player_box">
                <div class="img_box">
                  <h2><span></span> 官方宣传</h2>
                  <div class="photos">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/ppd-1.271193a9b9d8037ccd54223f6ec5eaf4.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      class="photo1"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/ppd-1.271193a9b9d8037ccd54223f6ec5eaf4.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/ppd-2.293ec10ec7564ee46748bdbf9f247d74.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      class="photo2"
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/ppd-2.293ec10ec7564ee46748bdbf9f247d74.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                  </div>
                </div>
                <div class="player_list">
                  <div class="player_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-1.03b25e2dd35d046e324b99f4fbcc8ccc.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-1.03b25e2dd35d046e324b99f4fbcc8ccc.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                  </div>
                  <div class="player_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-2.58e2416d697bc8482ca0a1a406863edc.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-2.58e2416d697bc8482ca0a1a406863edc.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                  </div>
                  <div class="player_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-3.9ef27db093ebc55dc0b32a32cbde5b54.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-3.9ef27db093ebc55dc0b32a32cbde5b54.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                  </div>
                  <div class="player_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-4.c92bd9f91a92025dacbb648a168257c3.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-4.c92bd9f91a92025dacbb648a168257c3.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                  </div>
                  <div class="player_item">
                    <img
                      data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-5.82f8725af1b3101f2792bfd086372ff7.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                      width="undefined"
                      height="undefined"
                      style=""
                      src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/player-5.82f8725af1b3101f2792bfd086372ff7.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div id="news" class="swiper-slide section section_six">
              <div class="news_box">
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/news.6d2fdbe72aa5f7e24a1bf71b4c97e6b0.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style=""
                  class="news"
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/news.6d2fdbe72aa5f7e24a1bf71b4c97e6b0.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/logos.1f34d881ca1aac6a8a487d7b96157d1e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style=""
                  class="logos"
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/juventus-web/logos.1f34d881ca1aac6a8a487d7b96157d1e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
              </div>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
            <span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1"></span><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 2"></span
            ><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 3"></span><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 4"></span
            ><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 5"></span><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 6"></span
            ><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 7"></span>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
      <div id="modal" class="modal"></div>
    </div>
    <div class="sponsorPage" id="main" v-if="type == 2">
     
        <div class="subNav"><a @click="changType(1)" class="juventus">尤文图斯官方区域合作伙伴</a> <a @click="changType(2)" class="avfc">阿斯顿维拉官方全球顶级合作伙伴</a></div>
            <img src="/static/image/banner.57c0282eccf86dd00ab9ee36ae51c98e.png" width="100%" alt="" />

      <div class="box" id="video">
        <div class="boxContent">
          <h1>官宣视频</h1>
          <div class="video">
            <video poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/video3.4d33a4e69f9fa8f3e03ec8617425c9f9.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp" style="" controls="" controlslist=" noremote footbar nodownload" preload="none">
              <source src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/avfc03.2e51fde2ffec17a7402d49710a98a82f.mp4" type="video/mp4" />
            </video>
            <div class="synopsis">
              <p>
                2021年6月22日,
                {{$store.state.appInfo.title}}成为阿斯顿维拉全球顶级合作伙伴及官方球衣袖标合作伙伴。{{$store.state.appInfo.title}}的品牌标志将出现在维拉2021/22赛季的新球衣袖标上,并将在所有阿斯顿维拉主客场及一线队的比赛中展现。届时，在全球最受瞩目的英超联赛上，{{$store.state.appInfo.title}}将携手阿斯顿维拉俱乐部为广大球迷和用户提供更好的赛事体验。不仅如此，双方的合作将覆盖全球诸多领域，包括比赛日的联合活动，全球范围的企业社会责任项目，以及其它贯穿维拉球迷和{{$store.state.appInfo.title}}用户的合作。
              </p>
              <div class="btn">
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/but-1@2x.35a6e77893e9d8ce0111433f95387711.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style=""
                  class="btn2"
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/but-1@2x.35a6e77893e9d8ce0111433f95387711.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="boxContent">
          <h1>精彩赛事</h1>
          <div class="swiper-container1">
            <div class="swiper-wrapper">
              <ul class="swiper-slide">
                <li class="slide-item">
                  <video poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/video1.6b6ca8c0a4b1d2b5fceb5207a09a00d6.jpg?x-oss-process=image/resize,m_fixed,w_2000,h_1124/quality,Q_100/format,webp" style="" controls="" preload="none">
                    <source src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/avfc01.c46046d6fa0b0908e34391b8a866d04f.mp4" type="video/mp4" />
                  </video>
                  <div class="videoTit">阿斯维拉精彩集锦①</div>
                </li>
                <li class="slide-item">
                  <video poster="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/video2.93d43044fc6a9e036723023bb99ac439.jpg?x-oss-process=image/resize,m_fixed,w_2000,h_1124/quality,Q_100/format,webp" style="" controls="" preload="none">
                    <source src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/videos/avfc02.618e0626a5f0af189b31f24331c62f89.mp4" type="video/mp4" />
                  </video>
                  <div class="videoTit">阿斯维拉精彩集锦②</div>
                </li>
                <li class="slide-item">
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/video0.52e172b7ec3ad5c87f42b7a85ba8187d.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style="cursor: default"
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/video0.52e172b7ec3ad5c87f42b7a85ba8187d.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <div class="videoTit">敬请期待</div>
                </li>
                <li class="slide-item">
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/video0.52e172b7ec3ad5c87f42b7a85ba8187d.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style="cursor: default"
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/video0.52e172b7ec3ad5c87f42b7a85ba8187d.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <div class="videoTit">敬请期待</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box" id="picture">
        <div class="boxContent">
          <div class="left">
            <div style="height: 204px">
              <h1>阿斯顿维拉足球俱乐部</h1>
              <p>阿斯顿维拉足球俱乐部（绰号维拉人）是一家位于英格兰中部伯明翰市的足球俱乐部，于1874年创立，现时于英格兰足球超级联赛竞逐，是1888年甲组联赛及1992年英格兰足球超级联赛首届赛事球队，因此阿斯顿维拉也是英超之中历史最悠久的球队之一，其主场位于伯明翰市的维拉公园球场。 　</p>
              <p>早年，阿斯顿维拉曾经七次赢得顶级联赛冠军和七次英格兰足总杯，更于1982年获得欧洲联赛冠军杯和欧洲超级杯冠军。</p>
            </div>
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor1.b769c4e6fe49ac2defecf6dc19443bd7.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="344"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor1.b769c4e6fe49ac2defecf6dc19443bd7.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor2.9dc36ae8b757f459e5d2615d1ba0b0e8.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="344"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor2.9dc36ae8b757f459e5d2615d1ba0b0e8.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </div>
          <div class="right">
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor3.833838cd6b550cd25b7c2b7aa59fb1f7.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="408"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor3.833838cd6b550cd25b7c2b7aa59fb1f7.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </div>
        </div>
        <div class="boxContent">
          <h1>荣誉</h1>
          <div class="swiper-container2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor4.97e7ee0b0134e0c320aa85e206c137de.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style=""
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor4.97e7ee0b0134e0c320aa85e206c137de.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <span>7</span> <span class="videoTit">英格兰甲级联赛</span>
                </div>
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor5.82db459ba1645cb9332958fd29ff453d.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style=""
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor5.82db459ba1645cb9332958fd29ff453d.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <span>2</span> <span class="videoTit">英格兰乙级联赛</span>
                </div>
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor6.c0bd6749bfb12007495f796536beab87.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style=""
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor6.c0bd6749bfb12007495f796536beab87.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <span>1</span> <span class="videoTit">欧洲冠军杯</span>
                </div>
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor7.4be891f2af8817c1cd112876ed987008.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style=""
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/honor7.4be891f2af8817c1cd112876ed987008.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <span>1</span> <span class="videoTit">欧洲超级杯</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" id="info">
        <div class="boxContent">
          <h1>球队日常图集</h1>
          <div class="signing">
            <div class="signingLeft">
              <img
                data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info1.e0437ed742eb3f47dfdf085fc60c16ef.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                width="undefined"
                height="undefined"
                style="width: 276px; height: 428px"
                src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info1.e0437ed742eb3f47dfdf085fc60c16ef.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              />
            </div>
            <div class="signingCenter">
              <img
                data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info2.7d1278213f2a252ed21527261a13afb0.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                width="undefined"
                height="undefined"
                style="width: 570px; height: 428px"
                src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info2.7d1278213f2a252ed21527261a13afb0.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              />
            </div>
            <div class="signingRight">
              <img
                data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info3.39e6fe7617fb8af27ce7ebada0061e7a.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                width="undefined"
                height="undefined"
                style="width: 276px; height: 276px"
                src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info3.39e6fe7617fb8af27ce7ebada0061e7a.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              />
              <div>
                <h1>比赛照片</h1>
                <p>左图为比赛准备开始麦克金蓄势待发中图为进球后队员互相击掌庆祝，图为埃尔加齐、英斯、扬、毕达斯、瓦特金斯右图为后场大将马蒂·卡什组织进攻</p>
              </div>
            </div>
          </div>
          <div class="swiper-container3">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info4.dc3e7ad3a9f82be99e3b50205d232027.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style="width: 276px; height: 260px"
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info4.dc3e7ad3a9f82be99e3b50205d232027.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <div class="videoTit">比赛照片，对决意甲萨勒尼塔纳赛</div>
                </div>
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info5.00a39625598474316cc23424200a7ea4.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style="width: 276px; height: 260px"
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info5.00a39625598474316cc23424200a7ea4.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <div class="videoTit">比赛照片，球队中场纳卡姆巴观察场上形势</div>
                </div>
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info6.2dbafc17b133ff729f009a4315f98079.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style="width: 276px; height: 260px"
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info6.2dbafc17b133ff729f009a4315f98079.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <div class="videoTit">比赛照片，英斯进球，瓦特金斯上前庆贺</div>
                </div>
                <div>
                  <img
                    data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info7.db32133bb6873f7f49312a7c1e7de2d3.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                    width="undefined"
                    height="undefined"
                    style="width: 276px; height: 260px"
                    src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/info7.db32133bb6873f7f49312a7c1e7de2d3.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  />
                  <div class="videoTit">比赛照片，赛季新援埃尔加齐</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" style="height: 960px" id="service">
        <div class="boxContent" style="padding: 42px 20px 46px 60px">
          <img
            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/service1.0c8e13297f172116c5cb79317edbccd4.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            width="undefined"
            height="undefined"
            style="width: 326px; height: 666px"
            class="iphone"
            src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/service1.0c8e13297f172116c5cb79317edbccd4.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
          />
          <div class="iphoneRight">
            <h1>业内最顶尖的原生APP</h1>
            <ul>
              <li>
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon1.1bc99f66a0b7e9e6b9ca558bf6c3dd5e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style=""
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon1.1bc99f66a0b7e9e6b9ca558bf6c3dd5e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
                <span>更安全</span>
                <p>
                  独家网络技术<br />
                  <br />
                  超强防劫持
                </p>
              </li>
              <li>
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon2.734efa6c74e38f374be642b74e2b4bb7.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style=""
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon2.734efa6c74e38f374be642b74e2b4bb7.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
                <span>更稳定</span>
                <p>
                  强大的技术团队<br />
                  <br />
                  提供最稳定的产品
                </p>
              </li>
              <li>
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon3.3f5358a4ec1c7cdc83cf6efd225fa2b4.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style=""
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon3.3f5358a4ec1c7cdc83cf6efd225fa2b4.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
                <span>更丰富</span>
                <p>
                  丰富的游戏产品<br />
                  <br />
                  您想要的我们都有
                </p>
              </li>
              <li>
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon4.babeaf82416d56ba4f992242f534186e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style=""
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/icon4.babeaf82416d56ba4f992242f534186e.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
                <span>更私密</span>
                <p>
                  三重数据加密<br />
                  <br />
                  保护您的资料安全
                </p>
              </li>
            </ul>
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/service2.37ff7c4c7b523bf110bcb5c01bf08fe5.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="undefined"
              height="undefined"
              style=""
              class="bottomImg"
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/service2.37ff7c4c7b523bf110bcb5c01bf08fe5.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </div>
        </div>
        <div class="license"></div>
      </div>
      <div class="box" id="official">
        <div class="boxContent" style="height: 564px">
          <h1>官方宣传</h1>
          <div class="official">
            <div class="officialLeft">
              <img
                data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official1.8b5ef6003632dcf1570ebbd5004b4821.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                width="undefined"
                height="undefined"
                style="width: 100%"
                src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official1.8b5ef6003632dcf1570ebbd5004b4821.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              />
            </div>
            <div class="officialRight">
              <div>
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official2.a805676e968affd950e310e0010ce46b.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style="width: 100%; height: 192px"
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official2.a805676e968affd950e310e0010ce46b.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
              </div>
              <div style="margin-top: 9px">
                <img
                  data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official3.d1e78174da8917670d434360df0817f3.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                  width="undefined"
                  height="undefined"
                  style="width: 100%; height: 276px"
                  src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official3.d1e78174da8917670d434360df0817f3.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
                />
              </div>
            </div>
          </div>
        </div>
        <ul class="officialList">
          <li>
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official4.eb2e77af73bf19f3d9f66e203e4da8e1.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="undefined"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official4.eb2e77af73bf19f3d9f66e203e4da8e1.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </li>
          <li>
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official5.98d5451746f3e31283625bd5fc533d97.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="undefined"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official5.98d5451746f3e31283625bd5fc533d97.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </li>
          <li>
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official6.578b522eca58cba74e72376767ac1c0f.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="undefined"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official6.578b522eca58cba74e72376767ac1c0f.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </li>
          <li>
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official7.ce5764598ec4c0cb6d45ce6146f71fd2.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="undefined"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official7.ce5764598ec4c0cb6d45ce6146f71fd2.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </li>
          <li>
            <img
              data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official8.a1505e9c6734e6a5d4f6454721d989f5.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
              width="undefined"
              height="undefined"
              style=""
              src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/official8.a1505e9c6734e6a5d4f6454721d989f5.jpg?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            />
          </li>
        </ul>
      </div>
      <div class="box" id="cooperation">
        <div class="media">
          <img
            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/media1.84d78d7b17623bf3e42e68dc15fc6cec.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            width="undefined"
            height="undefined"
            style="width: 1218px; height: 648px; display: block"
            src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/media1.84d78d7b17623bf3e42e68dc15fc6cec.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
          />
          <img
            data-src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/cooperation.c2c4e4f308fb1919065e64a38b38e01a.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
            width="undefined"
            height="undefined"
            style="width: 1218px; height: 174px; display: block; margin-top: 30px"
            src="https://senbackkg.salinent.com/static-sponsor/assets-oss/ob/images/avfc-web/cooperation.c2c4e4f308fb1919065e64a38b38e01a.png?x-oss-process=image/resize,p_100/quality,Q_100/format,webp"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gamePage',
  data() {
    return {
      type: 1,
    };
  },
  components: {},
  created() {
    let that = this;
    that.$parent.showLoading();
    var query = that.$route.query;
    console.log(query)
    if (query.type) {
      that.type = query.type;
    }
    setTimeout(() => {
      that.$parent.hideLoading();
    }, 2000);
  },
  mounted() {},
  methods: {
    changType(type) {
      this.type = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/utils.541ae06c.css';
@import '../../static/css/web.99fa79d0.css';
@import '../../static/css/web.c730ea31.css';
</style>



// WEBPACK FOOTER //
// src/components/asdwl.vue